import { Injectable, Inject, LOCALE_ID } from "@angular/core";

import {
  TradeDealPromiseService,
  BfxBlotterAction,
  ContextMenuItemState,
} from "shared/cubiq-services";

import { BfxBaseBlotter } from "../bfx-base-blotter/bfx-base-blotter";
import { BfxBlotterActionEvent } from "../bfx-base-blotter/bfx-base-blotter-contextmenu.service";
import { BfxBlotterOrdersContextMenuService } from "../bfx-blotter-orders/bfx-blotter-orders-contextmenu.service";
import { BfxRBACService } from "../bfx-common/services/bfx-rbac.service";
import {
  BfxTradeContextMenuService,
  BfxBlotterTradeContextMenuItem,
} from "../bfx-blotter-trade/services/bfx-trade-contextmenu.service";
import { BfxUserProfileService } from "../bfx-common/services/bfx-user-profile.service";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class BfxFindDealsContextMenuService extends BfxTradeContextMenuService {
  constructor(
    tradeDealService: TradeDealPromiseService,
    rbacService: BfxRBACService,
    userProfileService: BfxUserProfileService,
    //@Inject(LOCALE_ID) localeId: string,
    // FIXME: is-a has-a
    private _bfxTradeContextMenuService: BfxTradeContextMenuService,
  ) {
    super(tradeDealService, rbacService, userProfileService); //localeId

    // FIXME move to a shared subject service avoid is-a & has-a combo
    this.actionSubject = _bfxTradeContextMenuService.actionSubject;
  }

  protected getEnabledActions(
    items: Array<any>,
    selectedOrderIds: Array<string>,
  ): Array<BfxBlotterAction> {
    let tradesCount: number = selectedOrderIds.length;
    let enabledActionIds: Array<BfxBlotterAction> = [];

    // OTHER
    if (tradesCount == 1) {
      enabledActionIds.push(BfxBlotterAction.ACTION_TRADE_VIEW_DETAILS);
      enabledActionIds.push(BfxBlotterAction.ACTION_TRADE_VIEW_TRADE_DETAILS);
    }

    if (tradesCount != 0) {
      enabledActionIds.push(BfxBlotterAction.ACTION_TRADE_EXPORT);
    }

    return enabledActionIds;
  }

  public buildMenu(
    blotter: BfxBaseBlotter,
    pageX: number,
    pageY: number,
    selectedIds: Array<string>,
    selectedItems?: Array<object> | null,
  ): void {
    // set up orderIds in items - don't lookup full order data

    if (!selectedItems) {
      logger.out.error(
        `${this.constructor.name}.doMenu called without selectedRow %O data`,
        selectedItems,
      );
    }

    let enabledItems: Array<BfxBlotterAction> = this.getEnabledActions(selectedItems, selectedIds);
    let actionDecorators: any = this.getActionDecorators(selectedItems);

    this.showMenuAt(blotter, pageX, pageY, enabledItems, actionDecorators);
  }

  protected initMenuItems(): void {
    this.menuItems = [];

    if (this.permissions.canViewDetails) {
      this.menuItems.push(
        new BfxBlotterTradeContextMenuItem(
          BfxBlotterAction.ACTION_TRADE_VIEW_DETAILS,
          "View Details",
        ),
      );
    }
    if (this.permissions.canViewTradeDetails) {
      this.menuItems.push(
        new BfxBlotterTradeContextMenuItem(
          BfxBlotterAction.ACTION_TRADE_VIEW_TRADE_DETAILS,
          "View Trade Details",
        ),
      );
    }

    this.menuItems.push(new BfxBlotterTradeContextMenuItem(BfxBlotterAction.SEPARATOR));

    if (this.permissions.canExportTrade) {
      this.menuItems.push(
        new BfxBlotterTradeContextMenuItem(BfxBlotterAction.ACTION_TRADE_EXPORT, "Export to CSV"),
      );
    }
  }

  public fireActionEvent(
    actionId: BfxBlotterAction,
    ladderBlotter: any,
    selectedIds?: Array<string>,
    selectedItems?: Array<any>,
    itemState?: ContextMenuItemState,
    hide?: boolean,
    menuBoundingClientRect?: any,
    actionEvent?: any,
  ): void {
    // unlike bfx-trade-contextmenu.service, selectedTradeDeals are unavailable
    // so never emit BfxBlotterTradeDialogActionEvent here
    let event: BfxBlotterActionEvent = new BfxBlotterActionEvent(
      actionId,
      ladderBlotter,
      this.getSelectedIds(selectedIds, ladderBlotter),
      this.getSelectedItems(selectedItems, ladderBlotter),
      itemState,
      hide,
      menuBoundingClientRect,
      actionEvent,
    );
    this.actionSubject.next(event);
  }
}
